import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import { withRouter } from 'react-router-dom';
import { myLog } from '../../../utils/Utility';
import { PATH } from '../../../utils/Constants';
import { logout } from '../../action/UserAction';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

class SocketDownScreen extends Component {
    static propTypes = {
        isUserActive: PropTypes.bool,
    };

    //handleRefresh
    handleRefresh = () => {
        window.location.reload();
    };

    //handleHomePage
    handleHomePage = () => {
        this.props.history.push(PATH.INDEX);
    };

    //_renderView
    _renderView() {
        const { isSocketDownProblem, isUserActive } = this.props;
        if (isUserActive) {
            logout(() => {
                window.location.href = '/';
            });
        } else if (isSocketDownProblem) {
            myLog('isSocketDownProblem', isSocketDownProblem);
            return (
                <div className="h-full w-full left-0 top-0">
                    <div className="w-full h-full flex items-center justify-center bg-neutral">
                        <div className="flex flex-col">
                            <div className="m-auto text-center">
                                <div className="mb-4">
                                    <div>
                                        <div className="flex items-center justify-center h-full">
                                            <div className="loader-container text-center">
                                                <Spinner color="#000" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="font-normal mb-4">
                                        {this.props.t('reconnectingPleaseWait')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return <div />;
        }
    }
    render() {
        return (
            <div
                className="h-full w-full"
                style={{
                    position: 'absolute',
                }}
            >
                {this._renderView()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isSocketDownProblem: state.NetworkInState.isSocketDownProblem,
        isUserActive: state.NetworkInState.isUserActive,
    };
};

const ConnectedSocketDownScreen = withLanguage(
    withRouter(connect(mapStateToProps, null)(SocketDownScreen))
);

export default (props) => (
    <LanguageProvider>
        <ConnectedSocketDownScreen {...props} />
    </LanguageProvider>
);
